import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import {postResendOtpCode} from './postResendOtpCode';

const usePostResendOtpCode = () => {
  const {mutate, isLoading, data} = useMutation({
    mutationFn: (bankValidationGuid: string) =>
      postResendOtpCode(bankValidationGuid),
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.messages?.[0] ||
          error?.response?.data?.message ||
          error?.message ||
          'خطا در ارسال کد تایید',
        {
          position: 'bottom-right',
        },
      );
    },
  });

  return {mutate, isLoading, data};
};

export default usePostResendOtpCode;
